<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        title="MANTENTE EN CONTACTO CON NOSOTROS"
        pace="6"
      >
        Si deseas información sobre algún artículo puedes comunicarte al +56 9 6741 5474 o si deseas una cotización puedes enviarnos tu solicitud al correo.
      </base-info-card>

      <base-business-contact dense />
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessInfo',

    props: { dark: Boolean },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Address',
          text: '8553 N. Beach St. Ste. 227<br>Fort Worth, Texas 76137',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Phone',
          text: '01 (800) 433 744<br>01 (800) 433 633',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'john@vuetifyjs.com<br>heather@vuetifyjs.com',
        },
      ],
    }),
  }
</script>
